module.exports = __webpack_public_path__ + "static/media/Gina Edmunds Headshot_1715249481259.f555eb72.jpeg";